module.exports=function(n){return 1==n?"one":"other"}